export const ProvinceCodes = {
  AB: 'AB',
  BC: 'BC',
  MB: 'MB',
  NB: 'NB',
  NL: 'NL',
  NS: 'NS',
  NT: 'NT',
  NU: 'NU',
  ON: 'ON',
  PE: 'PE',
  QC: 'QC',
  SK: 'SK',
  YT: 'YT',
} as const;

export const Regions = {
  CAN: 'CAN',
  USA: 'USA',
  GBR: 'GBR',
} as const;

export const ComplianceTypes = {
  CPD: 'CPD',
  CPE: 'CPE',
} as const;

export const ComplianceTypeToApiQueryParam = {
  [ComplianceTypes.CPD]: 'canada',
  [ComplianceTypes.CPE]: 'usa',
} as const;

export const RegionToComplianceType = {
  [Regions.CAN]: ComplianceTypes.CPD,
  [Regions.USA]: ComplianceTypes.CPE,
  [Regions.GBR]: ComplianceTypes.CPD,
} as const;
